/*fx.ns("filters", class MediaFilter extends fx.Filter {

	constructor(mediaType)
	{
        super();

        this._mediaType = mediaType;
    }

    get mediaType()
    {
        return this._mediaType;
    }

    set mediaType(val)
    {
        this._mediaType = val;
        this._changed = true;
        this.trigger("updated");
    }

    get search()
    {
        return this._search;
    }

    set search(val)
    {
        this._search = val;
    }


    exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = this.rawData.filter( (a) => a.model ==  this.mediaType && a.media).sort( (a, b) => a.position - b.position);

        if (media.visible || (media.available && media.removable))
        
		return this.transformedData;
	}	

    
});*/